import type { AreaDict } from '../messages'

const tagform: AreaDict = {
  'pt-BR': {
    'tagf.errName': 'Informe um nome',
    'tagf.errSave': 'Erro ao salvar',
    'tagf.updated': 'Tag atualizada',
    'tagf.created': 'Tag criada',
    'tagf.editTitle': 'Editar tag',
    'tagf.newTitle': 'Nova tag',
    'tagf.desc': 'Ao renomear, o novo nome é propagado nas transações que já usam esta tag.',
    'tagf.name': 'Nome',
    'tagf.descLabel': 'Descrição',
    'tagf.descPlaceholder': 'Opcional',
  },
  en: {
    'tagf.errName': 'Enter a name',
    'tagf.errSave': 'Error saving',
    'tagf.updated': 'Tag updated',
    'tagf.created': 'Tag created',
    'tagf.editTitle': 'Edit tag',
    'tagf.newTitle': 'New tag',
    'tagf.desc': 'When renaming, the new name is propagated to the transactions that already use this tag.',
    'tagf.name': 'Name',
    'tagf.descLabel': 'Description',
    'tagf.descPlaceholder': 'Optional',
  },
  es: {
    'tagf.errName': 'Ingresa un nombre',
    'tagf.errSave': 'Error al guardar',
    'tagf.updated': 'Etiqueta actualizada',
    'tagf.created': 'Etiqueta creada',
    'tagf.editTitle': 'Editar etiqueta',
    'tagf.newTitle': 'Nueva etiqueta',
    'tagf.desc': 'Al renombrar, el nuevo nombre se propaga a las transacciones que ya usan esta etiqueta.',
    'tagf.name': 'Nombre',
    'tagf.descLabel': 'Descripción',
    'tagf.descPlaceholder': 'Opcional',
  },
}

export default tagform
